import { useState } from 'react';

//vendor
import ReactPlayer from 'react-player/lazy';

// styles
import {
  Wrapper,
  VideoWrapper,
  ClosingIcon,
  PlayingIcon,
  Thumbnail,
  Video,
} from './VideoPlayer.styles';

//icons
import { IconClose } from '@loadsmart/icons';
import IconPlay from '@/public/images/carrier-tms/video-hero/icon-play.svg';

export function VideoPlayer({ content }) {
  const [playVideo, setPlayVideo] = useState(false);

  return (
    <Wrapper>
      <VideoWrapper className={playVideo ? `active` : ``}>
        <ClosingIcon
          onClick={() => {
            setPlayVideo(false);
          }}
        >
          <IconClose />
        </ClosingIcon>
        {playVideo && content.youtube && (
          <ReactPlayer
            className="react-player"
            url={content.youtube}
            controls
            playing={playVideo}
            width="100%"
            height="100%"
          />
        )}
      </VideoWrapper>
      <Thumbnail
        className={playVideo ? `inactive` : ``}
        onClick={() => {
          setPlayVideo(true);
        }}
        role="button"
      >
        {content.thumb && content.preview && (
          <Video
            autoPlay
            playsinline
            muted
            loop
            preload="auto"
            poster={content.thumb}
          >
            <source src={content.preview} type="video/webm" />
          </Video>
        )}
        <PlayingIcon>
          <IconPlay />
          <span>Play video</span>
        </PlayingIcon>
      </Thumbnail>
    </Wrapper>
  );
}
